import React from 'react';
import MDSpinner from 'react-md-spinner';
import { useTheme } from 'styled-components';

import { Variant } from './types';

interface SpinnerProps {
  /**
   * Color of the spinner
   */
  color?: string;
  /**
   * Size of the spinner in `px`
   */
  size?: number;
}

const Spinner = ({ color, size = 16 }: SpinnerProps) => {
  const theme = useTheme();

  return (
    <MDSpinner
      data-cy="loadingSpinner"
      singleColor={color || theme.color.background.primary.default()}
      size={size}
      borderSize={2}
    />
  );
};

Spinner.Variant = Variant;

export default Spinner;
